import React, { ReactNode, SyntheticEvent } from 'react';

import { Help } from '@mui/icons-material';
import { Box } from '@mui/material';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import MUIToolTip, { TooltipProps as MUITooltipProps } from '@mui/material/Tooltip';

import { colors } from '../../style';

import YubiIcon, { YubiIconProps } from '../YubiIcon';

type Props = Omit<MUITooltipProps, 'children'>;
interface TooltipProps extends Props {
  children?: ReactNode;
  iconProps?: YubiIconProps;
}

function Tooltip({
  id,
  children,
  title = '',
  placement = 'right',
  disableHoverListener = true,
  disableFocusListener = true,
  disableTouchListener = false,
  iconProps,
}: TooltipProps) {
  const [open, setOpen] = React.useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };
  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <MUIToolTip
        id={id}
        placement={placement}
        title={title}
        onClose={handleTooltipClose}
        open={open}
        arrow
        disableFocusListener={disableFocusListener}
        disableHoverListener={disableHoverListener}
        disableTouchListener={disableTouchListener}
        leaveDelay={1500}
        onMouseEnter={() => !disableHoverListener && handleTooltipOpen()}
        onMouseLeave={() => !disableHoverListener && handleTooltipClose()}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }} data-for={id} data-testid={`tooltip-${id}`}>
          {!children && iconProps && <YubiIcon {...iconProps} clickable />}
          {!children && !iconProps && (
            <Help
              data-testid="yubi-icon-Help"
              sx={{ fill: colors.secondary100, cursor: 'pointer' }}
              onClick={(e: SyntheticEvent) => {
                e.preventDefault();
                setOpen(!open);
              }}
            />
          )}
          {children}
        </Box>
      </MUIToolTip>
    </ClickAwayListener>
  );
}

export default Tooltip;
